import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { AuthService } from '../shared/auth.service';
//import { NotificationService } from '../notification/notification.service';
import { ResetFormService } from './reset-form.service';
import { NotificationService } from '../notification.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [ResetFormService]
})
export class LoginComponent implements OnInit {
  loginUser: FormGroup;
  submitted: Boolean = false;
  constructor(
    public _formBuilder: FormBuilder,
    public _router: Router,
    public _authService: AuthService,
    public _notificationService:NotificationService,
    public _resetFormService: ResetFormService
  ) { }

  ngOnInit(): void {
    this.setForm();
  }
  login(user) {
   //// console.log(user);
    this.submitted = true;
    user.Password = btoa(user.Password)
    if (this.loginUser.valid) {
      this._authService.login(user)
        .subscribe(response => {
         //// console.log('login response', response);
        //console.log(response);
          if (response.result) {
            ////console.log("test");
            // this._notificationService.showNotification({type:'success',message :response.msg});
            this._authService.loggedIn = true;

            sessionStorage.setItem('NIBNumber', response.nibnumber);
            this._authService.NIBNumber = sessionStorage.getItem('NIBNumber');   
            ////console.log(this._authService.NIBNumber)                  ;

            sessionStorage.setItem('token', response.access_token);
            this._authService.token = sessionStorage.getItem('token');          


            sessionStorage.setItem('LoginType', response.logintype);
            this._authService.LoginType = sessionStorage.getItem('LoginType');  

//console.log(this._authService.LoginType)


            this.submitted = false;
            ////console.log(this._authService.token, response.access_token);
            if (response.requirePasswordChange == true) {
              this._notificationService.showNotification({ type: 'warning', message: 'Please reset your password' });
              this._router.navigate(['/profile']);
            }
            else {
             //// console.log("test else");
              this._notificationService.showNotification({ type: 'success', message: response.msg});         
              
             
              this._router.navigate(['/dashboard']);
            }

          }
          else {

            ////console.log("test");
            // this._notificationService.showNotification({ type: 'error', message:response.msg})
            this._notificationService.showNotification({ type: 'error', message: response['msg'] });
            this._router.navigate(['/']);
            this.loginUser.controls['NIBNumber'].setValue('');
            this.loginUser.controls['Password'].setValue('');
            //this._notificationService.showNotification({type:'error',message:response['msg']});
          }
        },
          (error) => {
          ////  console.log('login form error11');
            //this._notificationService.showNotification({type:'error',message:'server error'});
          });
    }
    else {
      ////console.log('login form error');
      this._notificationService.showNotification({ type: 'error', message: "Please fill all the details."});
    }
  }
  setForm() {
    this.loginUser = this._formBuilder.group({
      'NIBNumber': ['', Validators.required],
      'Password': ['', Validators.required],
    });
  }
}